module.exports = __webpack_public_path__ + "img/drop-down.96f79d0d.svg";